import { Dispatch, SetStateAction, createContext } from "react";
import { IDistributionOrder } from "types/admin";

interface t {order: IDistributionOrder, frozen: boolean, setOrder: Dispatch<SetStateAction<IDistributionOrder>>}

export type IOrderContext = t

const orderContext = createContext<t>({} as t)

export default orderContext